module.exports = __webpack_public_path__ + "img/clock.a61a1cca.svg";